import React, { PropTypes } from "react";
import DateConstants from "./DateConstants";
import { getTitleString } from "../util/";
import util from "../../../_util/util";

function isSameDay(one, two) {
  return one && two && one.compareToDay(two) === 0;
}

function getStartOfMonth(startOfMonth = 1) {
  return startOfMonth > 28 ? 1 : startOfMonth;
}

function getAddMonthOfToday(today, startOfMonth) {
  const cloneToday = today.clone();
  return cloneToday.getDayOfMonth() < startOfMonth ? -1 : 0;
}

function getYearAndMonth(value, addMonth) {
  let year = value.getYear();
  let month = value.getMonth() + addMonth;
  if (month == -1) {
    month = 11;
    year -= 1;
  }
  return { year, month };
}

function beforeCurrentMonthYear(current, today, addMonth = 0, startOfMonth) {
  const colneCurrent = current.clone();
  const cloneToday = today.clone();
  const { year, month } = getYearAndMonth(cloneToday, addMonth);
  cloneToday.set(year, month, startOfMonth);
  return (
    current.getYear() < year ||
    (current.getYear() === year && colneCurrent.compareToDay(cloneToday) < 0)
  );
  // if (current.getYear() < today.getYear()) {
  //   return 1;
  // }
  // return current.getYear() === today.getYear() &&
  //   current.getMonth() < today.getMonth();
}

function afterCurrentMonthYear(current, today, addMonth = 0, startOfMonth) {
  const colneCurrent = current.clone();
  const cloneToday = today.clone();
  if (current.getYear() > today.getYear()) {
    return 1;
  }
  cloneToday.set(
    cloneToday.getYear(),
    cloneToday.getMonth() + addMonth + 1,
    startOfMonth
  );
  return (
    current.getYear() === today.getYear() &&
    colneCurrent.compareToDay(cloneToday) >= 0
  );
  // if (current.getYear() > today.getYear()) {
  //   return 1;
  // }
  // return current.getYear() === today.getYear() &&
  //   current.getMonth() > today.getMonth();
}

function getIdFromDate(date) {
  return `rc-calendar-${date.getYear()}-${date.getMonth()}-${date.getDayOfMonth()}`;
}

function noop() {}

function handleDayClick(current) {
  this.props.onSelect(current);
}

function handleCellMouseEnter(current) {
  this.props.onDayHover(current);
}

const DateTBody = React.createClass({
  propTypes: {
    contentRender: PropTypes.func,
    dateRender: PropTypes.func,
    disabledDate: PropTypes.func,
    prefixCls: PropTypes.string,
    selectedValue: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object)
    ]),
    value: PropTypes.object,
    showWeekNumber: PropTypes.bool
  },

  getDefaultProps() {
    return {
      onDayHover: noop
    };
  },

  render() {
    const props = this.props;
    const {
      contentRender,
      prefixCls,
      selectedValue,
      value,
      showWeekNumber,
      dateRender,
      fixWeekLength = true,
      disabledDate,
      ecId
    } = props;
    let iIndex;
    let jIndex;
    let current;
    const dateTable = [];
    const today = value.clone();
    const cellClass = `${prefixCls}-cell`;
    const weekNumberCellClass = `${prefixCls}-week-number-cell`;
    const dateClass = `${prefixCls}-date`;
    const todayClass = `${prefixCls}-today`;
    const selectedClass = `${prefixCls}-selected-day`;
    const inRangeClass = `${prefixCls}-in-range-cell`;
    const lastMonthDayClass = `${prefixCls}-last-month-cell`;
    const nextMonthDayClass = `${prefixCls}-next-month-btn-day`;
    const disabledClass = `${prefixCls}-disabled-cell`;
    const firstDisableClass = `${prefixCls}-disabled-cell-first-of-row`;
    const lastDisableClass = `${prefixCls}-disabled-cell-last-of-row`;
    const weekendClass = `${prefixCls}-weekend-of-row`;
    today.setTime(Date.now());
    const startOfMonth = getStartOfMonth(this.props.startOfMonth);
    const addMonth = getAddMonthOfToday(today, startOfMonth);
    const month1 = value.clone();
    const { year, month } = getYearAndMonth(value, addMonth);
    month1.set(year, month, startOfMonth);
    // month1.set(value.getYear(), value.getMonth(), 1);
    const day = month1.getDayOfWeek();
    const lastMonthDiffDay = (day + 7 - value.getFirstDayOfWeek()) % 7;
    // calculate last month
    const lastMonth1 = month1.clone();
    lastMonth1.addDayOfMonth(0 - lastMonthDiffDay);
    let passed = 0;
    let weekLength = DateConstants.DATE_ROW_COUNT;
    if (!fixWeekLength) {
      weekLength -= 1;
      /* 获取本月的有几周 */
      const test = lastMonth1.clone();
      test.addDayOfMonth(weekLength * 7 - 1);
      if (test.getMonth() === month) {
        test.addDayOfMonth(1);
        if (test.getMonth() === month) {
          weekLength += 1;
        }
      }
    }

    for (iIndex = 0; iIndex < weekLength; iIndex++) {
      for (jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;
        if (passed) {
          current = current.clone();
          current.addDayOfMonth(passed);
        }
        dateTable.push(current);
        passed++;
      }
    }
    const tableHtml = [];
    passed = 0;
    for (iIndex = 0; iIndex < weekLength; iIndex++) {
      let weekNumberCell;
      const dateCells = [];
      if (showWeekNumber) {
        weekNumberCell = (
          <td
            key={dateTable[passed].getWeekOfYear()}
            role="gridcell"
            className={weekNumberCellClass}
          >
            {dateTable[passed].getWeekOfYear()}
          </td>
        );
      }
      for (jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
        let next = null;
        let last = null;
        current = dateTable[passed];
        if (jIndex < DateConstants.DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }
        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }
        let cls = cellClass;
        let disabled = false;
        let selected = false;

        if (util.isWeekendDay(current.time)) {
          cls += ` ${weekendClass}`;
        }

        if (isSameDay(current, today)) {
          cls += ` ${todayClass}`;
        }
        const isBeforeCurrentMonthYear = beforeCurrentMonthYear(
          current,
          value,
          addMonth,
          startOfMonth
        );
        const isAfterCurrentMonthYear = afterCurrentMonthYear(
          current,
          value,
          addMonth,
          startOfMonth
        );

        if (selectedValue && Array.isArray(selectedValue)) {
          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            const startValue = selectedValue[0];
            const endValue = selectedValue[1];
            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
              }
            }
            if (startValue && endValue) {
              if (isSameDay(current, endValue) && !selectedValue.hovering) {
                selected = true;
              } else if (
                current.compareToDay(startValue) > 0 &&
                current.compareToDay(endValue) < 0
              ) {
                cls += ` ${inRangeClass}`;
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
        }
        if (isBeforeCurrentMonthYear) {
          cls += ` ${lastMonthDayClass}`;
        }
        if (isAfterCurrentMonthYear) {
          cls += ` ${nextMonthDayClass}`;
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += ` ${firstDisableClass}`;
            }

            if (!next || !disabledDate(next, value)) {
              cls += ` ${lastDisableClass}`;
            }
          }
        }

        if (selected) {
          cls += ` ${selectedClass}`;
        }

        if (disabled) {
          cls += ` ${disabledClass}`;
        }

        let dateHtml;
        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          const content = contentRender
            ? contentRender(current, value)
            : current.getDayOfMonth();
          dateHtml = (
            <div
              key={getIdFromDate(current)}
              className={dateClass}
              aria-selected={selected}
              aria-disabled={disabled}
            >
              {content}
            </div>
          );
        }

        dateCells.push(
          <td
            ecId={`${ecId}_td@wxsy7v@${passed}`}
            key={passed}
            onClick={disabled ? noop : handleDayClick.bind(this, current)}
            onMouseEnter={
              disabled ? noop : handleCellMouseEnter.bind(this, current)
            }
            role="gridcell"
            title={getTitleString(current)}
            className={cls}
          >
            {dateHtml}
          </td>
        );

        passed++;
      }
      tableHtml.push(
        <tr key={iIndex} role="row">
          {weekNumberCell}
          {dateCells}
        </tr>
      );
    }
    return <tbody className={`${prefixCls}tbody`}>{tableHtml}</tbody>;
  }
});

export default DateTBody;



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/date/DateTBody.jsx